<template>
<div class="chapter">
<div class="inner_page">
<div id="toc"><h1 id="toc-title">The Eternal Effo</h1>
<ol class="toc" style="font-weight: bold;"><li id="toc-li-1"><a href="#/text/ch001#about-the-author">About the Author</a></li>
<li id="toc-li-2"><a href="#/text/ch002#dedication">Dedication</a></li>
<li id="toc-li-3"><a href="#/text/ch003#copyright-information">Copyright Information ©</a></li>
<li id="toc-li-4"><a href="#/text/ch004#acknowledgement">Acknowledgement</a></li>
<li id="toc-li-5"><a href="#/text/ch005#introduction">Introduction</a></li>
<li id="toc-li-6"><a href="#/text/ch006#authors-note">Author’s Note</a></li>
<li id="toc-li-7"><a href="#/text/ch007#chapter-1-beginnings">Chapter 1: Beginnings</a></li>
<li id="toc-li-8"><a href="#/text/ch008#chapter-2-flying-the-line">Chapter 2: Flying the Line</a></li>
<li id="toc-li-9"><a href="#/text/ch009#chapter-3-jets">Chapter 3: Jets</a></li>
<li id="toc-li-10"><a href="#/text/ch010#chapter-4-moving-on">Chapter 4: Moving On</a></li>
<li id="toc-li-11"><a href="#/text/ch011#chapter-5-the-next-step">Chapter 5: The Next Step</a></li>
<li id="toc-li-12"><a href="#/text/ch012#chapter-6-wanting-more">Chapter 6: Wanting More</a></li>
<li id="toc-li-13"><span href="#/text/ch013#chapter-7-redundancy-part-1" title="Link target outside of Sample">Chapter 7: Redundancy (Part 1)</span></li>
<li id="toc-li-14"><span href="#/text/ch014#chapter-8-return-to-the-fold" title="Link target outside of Sample">Chapter 8: Return to the Fold</span></li>
<li id="toc-li-15"><span href="#/text/ch015#chapter-9-a-square-peg-in-a-round-hole" title="Link target outside of Sample">Chapter 9: A Square Peg in a Round Hole?</span></li>
<li id="toc-li-16"><span href="#/text/ch016#chapter-10-commuting" title="Link target outside of Sample">Chapter 10: Commuting</span></li>
<li id="toc-li-17"><span href="#/text/ch017#chapter-11-enough-already" title="Link target outside of Sample">Chapter 11: Enough Already</span></li>
<li id="toc-li-18"><span href="#/text/ch018#chapter-12-so-what-happened-next" title="Link target outside of Sample">Chapter 12: So What Happened Next?</span></li>
<li id="toc-li-19"><span href="#/text/ch019#chapter-13-flying-rich-bastards-about" title="Link target outside of Sample">Chapter 13: Flying Rich Bastards About</span></li>
<li id="toc-li-20"><span href="#/text/ch020#chapter-14-redundancy-part-2" title="Link target outside of Sample">Chapter 14: Redundancy (Part 2)</span></li>
<li id="toc-li-21"><span href="#/text/ch021#chapter-15-cargo" title="Link target outside of Sample">Chapter 15: Cargo</span></li>
<li id="toc-li-22"><span href="#/text/ch022#chapter-16-india" title="Link target outside of Sample">Chapter 16: India</span></li>
<li id="toc-li-23"><span href="#/text/ch023#chapter-17-hong-kong-you-want-happy-ending-with-that" title="Link target outside of Sample">Chapter 17: Hong Kong-You Want Happy Ending with That?</span></li>
<li id="toc-li-24"><span href="#/text/ch024#chapter-18-shanghai-is-it-real-or-is-it-memorex" title="Link target outside of Sample">Chapter 18: Shanghai, Is It Real or Is It Memorex?</span></li>
<li id="toc-li-25"><span href="#/text/ch025#chapter-19-other-places" title="Link target outside of Sample">Chapter 19: Other Places</span></li>
<li id="toc-li-26"><span href="#/text/ch026#chapter-20-redundancy-part-3" title="Link target outside of Sample">Chapter 20: Redundancy (Part 3)</span></li>
<li id="toc-li-27"><span href="#/text/ch027#chapter-21-take-a-deep-breath-and-exhale" title="Link target outside of Sample">Chapter 21: Take a Deep Breath and Exhale</span></li>
<li id="toc-li-28"><span href="#/text/ch028#chapter-22-yorkshire-airlines" title="Link target outside of Sample">Chapter 22: Yorkshire Airlines</span></li>
<li id="toc-li-29"><span href="#/text/ch029#chapter-23-wizz-bang-command" title="Link target outside of Sample">Chapter 23: Wizz Bang-Command</span></li>
<li id="toc-li-30"><span href="#/text/ch030#chapter-24-the-plague" title="Link target outside of Sample">Chapter 24: The Plague</span></li>
<li id="toc-li-31"><span href="#/text/ch031#chapter-25-a-crm-of-comfort" title="Link target outside of Sample">Chapter 25: A CRM of Comfort</span></li>
<li id="toc-li-32"><span href="#/text/ch032#chapter-26-how-i-avoided-a-career-in-aviation" title="Link target outside of Sample">Chapter 26: How I Avoided a Career in Aviation</span></li>
</ol>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?742b328a